import TomSelect from "tom-select"
import { Controller } from "@hotwired/stimulus"
import { startIcons } from "../import_lucid"

export default class extends Controller {
  connect() {
    const renderRow = (data, escape) => `
      <div class="flex items-center gap-2 py-1">
        <i data-lucide="${escape(data.value)}" class="w-4 h-4 text-gray-700"></i>
        <span>${escape(data.text)}</span>
      </div>
    `

    const paintIcons = (root) => {
      if (root) startIcons(root)
    }

    this.element.tomselect = new TomSelect(this.element, {
      plugins: ["caret_position"],
      openOnFocus: true,
      maxOptions: 1000,
      render: {
        option: renderRow,
        item: renderRow,
      },
      onInitialize() {
        paintIcons(this.control)
      },
      onDropdownOpen(dropdown) {
        paintIcons(dropdown)
      },
      onType() {
        queueMicrotask(() => paintIcons(this.dropdown_content))
      },
      onItemAdd() {
        paintIcons(this.control)
      },
    })
  }

  disconnect() {
    if (this.element.tomselect) this.element.tomselect.destroy()
  }
}
